var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'dp-legend-label': true,
    'dp-legend-label--disabled': _vm.isDisabled,
  },on:{"click":function () { return _vm.toggleItem(_vm.item); }}},[_c('span',{staticClass:"dp-legend-label__colour",style:({ background: _vm.item.colour })}),_c('span',{staticClass:"dp-legend-label__label"},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }